<template>
    <span>
        <v-btn icon @click="dialog = true">
            <v-icon x-large class="initials" color="white">mdi-help-circle</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-card-title class="headline">
                    {{ $t('header.incident.title') }}
                </v-card-title>

                <v-card-text>
                    <p>{{ $t('header.incident.message') }}</p>
                    <v-textarea v-model="incidentMessage" outlined rows="5" :label="$t('header.incident.textareaLabel')" />
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="secondary" @click="dialog = false" :disabled="loading">
                        {{ $t('header.incident.closeButton') }}
                    </v-btn>
                    <v-btn color="primary" @click="sendIncident" :loading="loading" :disabled="!incidentMessage || loading">
                        {{ $t('header.incident.sendButton') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <template>
            <v-snackbar v-model="alert.showAlert" :timeout="300">
                {{ alert.message }}
                <template v-slot:actions>
                    <v-btn text @click="alert.showAlert = false">{{ $t('header.incident.closeButton') }}</v-btn>
                </template>
            </v-snackbar>
        </template>
    </span>
</template>

<script>
import { api } from '@/utils/api';

export default {
    data() {
        return {
            dialog: false,
            incidentMessage: '',
            loading: false,
            alert: {
                showAlert: false,
                message: null,
                color: 'success'
            }
        };
    },
    methods: {
        async sendIncident() {
            this.loading = true;
            try {
                const requestBody = {
                    subject: this.incidentMessage,
                    page: window.location.href,
                    clientIncidentEmails: this.$store.state?.clients?.incidentEmails || null,
                    user: this.$store.state.user?.informations?.email
                };

                await api.post(['mail', 'incident'], null, requestBody);

                this.dialog = false;

                this.$nextTick(() =>
                    setTimeout(() => {
                        this.$store.commit('displayMessage', { message: this.$t('header.incident.success'), color: 'green' });
                    }, 50)
                );
            } catch (error) {
                this.$nextTick(() =>
                    setTimeout(() => {
                        this.$store.commit('displayMessage', { message: this.$t('header.incident.error'), color: 'red' });
                    }, 50)
                );

                console.error(error);
            } finally {
                this.loading = false;
            }
        }
    },
    watch: {
        dialog(newVal) {
            if (!newVal) {
                this.incidentMessage = '';
            }
        }
    }
};
</script>
<style scoped>
.initials {
    border-radius: 50%;
    border: 2px solid white;
    background-color: #3200e6;
    color: #3200e6;
    text-transform: uppercase;
    font-weight: 900 !important;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
}
</style>
